import { useQuery } from "@tanstack/react-query";
import { fetchCombos } from "@/lib/api";

// ComboResponseDto: { buildingTypes, documents, metros, operationTypes,
// ownerTypes, propertyTypes, propertyColors, regions, repairRates,
// roomCounts, targets } — each item is { value, label, data }.
export const useReference = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["combos"],
    queryFn: fetchCombos,
    staleTime: 1000 * 60 * 30,
  });
  return { ref: data, isLoading };
};
